import React from "react";
import { useState } from "react";
import { useLocale } from "../../context/LocaleContext";
import { Button, Collapse, Stack } from "@mui/material";
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';

export default function AdvancedFilter({ children }) {
	const { messages } = useLocale()
	const [expanded, setExpanded] = useState(false);
	return (
		<>
			<Stack alignItems='flex-end'>
				<Button
					variant="text"
					startIcon={<TuneRoundedIcon />}
					sx={{ color: '#000000' }}
					endIcon={<KeyboardArrowUpRoundedIcon sx={{ transform: expanded ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.25s', marginTop: '10px', marginBottom: '10px' }} />}
					onClick={() => setExpanded(!expanded)}
					disableRipple
					disableFocusRipple
				>
					{messages.common.filters}
				</Button>
			</Stack>
			<Collapse in={expanded}>
				{children}
			</Collapse>
		</>
	)
}